// @ts-nocheck
import {
  FETCH_SURVEY_TEMPLATES_REQUEST,
  FETCH_SURVEY_TEMPLATES_SUCCESS,
  FETCH_SURVEY_TEMPLATES_FAILURE,
  UPSERT_SURVEY_TEMPLATE_REQUEST,
  UPSERT_SURVEY_TEMPLATE_SUCCESS,
  UPSERT_SURVEY_TEMPLATE_FAILURE,
} from "../constants/surveys";

export const initialState = {
  // { client: {...template}, contractor: {...template} }
  templatesByAudience: {},
  loading: false,
  saving: false,
};

const surveysReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SURVEY_TEMPLATES_REQUEST:
      return { ...state, loading: true };

    case FETCH_SURVEY_TEMPLATES_SUCCESS: {
      const items = Array.isArray(action.payload) ? action.payload : [];
      const byAudience = {};
      for (const t of items) {
        if (t?.audience) byAudience[t.audience] = t;
      }
      return { ...state, loading: false, templatesByAudience: byAudience };
    }

    case FETCH_SURVEY_TEMPLATES_FAILURE:
      return { ...state, loading: false };

    case UPSERT_SURVEY_TEMPLATE_REQUEST:
      return { ...state, saving: true };

    case UPSERT_SURVEY_TEMPLATE_SUCCESS: {
      const t = action.payload;
      if (!t?.audience) return { ...state, saving: false };
      return {
        ...state,
        saving: false,
        templatesByAudience: { ...state.templatesByAudience, [t.audience]: t },
      };
    }

    case UPSERT_SURVEY_TEMPLATE_FAILURE:
      return { ...state, saving: false };

    default:
      return state;
  }
};

export default surveysReducer;
